<div class="coverage-row">
    <div class="coverage-col-desc">{{data.description}}</div>
    <div class="coverage-col-capital">{{data.capital}}</div>
    <div class="coverage-col-free">
        <span [ngClass]="{'coverage-empty': !data.capitalFree || data.capitalFree === '---' || data.capitalFree === ''}">
            {{data.capitalFree || '---'}}
        </span>
    </div>
</div>
